// extracted by mini-css-extract-plugin
export default {"Homepage":"Homepage_Homepage__S8OU8"};